<template>
	<v-container fluid>
		<Email
			:entity="'invoices'"
			:objectId="sendModalId"
			:show="sendModalShow"
			@callback="sendModalCallback"
		/>
		<div class="bottom-buttons-outer">
			<v-btn color="success" @click="backClick">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t("buttons.back") }}
			</v-btn>
			<v-btn color="success" @click="saveClick">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t("buttons.save") }}
			</v-btn>
			<v-btn v-if="invoice.id != 0" color="success" @click="emailClick">
				<v-icon small>fa-envelope</v-icon>&nbsp;{{
					$t("buttons.saveAndEmail")
				}}
			</v-btn>
			<v-btn v-if="invoice.id != 0" color="success" @click="pdfClick">
				<v-icon small>fa-file-pdf</v-icon>&nbsp;{{
					$t("buttons.saveAndPrint")
				}}
			</v-btn>
			<v-btn v-if="cancelEnabled" color="error" @click="cancelClick">
				<v-icon small>fa-times</v-icon>&nbsp;{{ $t("buttons.cancel") }}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex lg8 md12 sm12 xl6 xs12>
				<v-layout row wrap>
					<v-flex md6 pa-1 xs12>
						<v-card>
							<v-card-text>
								<v-layout row wrap>
									<v-flex xs12>
										<v-radio-group
											v-model="invoice.customer_type"
											:readonly="fromGroupLock"
											row
										>
											<template slot="label"></template>
											<v-radio
												:label="$t('labels.person')"
												:value="'people'"
											></v-radio>
											<v-radio
												:label="$t('labels.company')"
												:value="'companies'"
											></v-radio>
										</v-radio-group>
									</v-flex>
									<v-flex
										v-show="
											invoice.customer_type == 'people'
										"
										xs12
									>
										<Dropdown
											v-model="invoice.subject_id"
											:ajax="true"
											:data="'subjects-people-buyers'"
											:error="
												invoiceValidation.subject_id
											"
											:label="'* ' + $t('fields.buyer')"
											:readonly="fromGroupLock"
										></Dropdown>
									</v-flex>
									<v-flex
										v-show="
											invoice.customer_type == 'companies'
										"
										xs12
									>
										<Dropdown
											v-model="invoice.subject_id"
											:ajax="true"
											:data="'subjects-companies-buyers'"
											:error="
												invoiceValidation.subject_id
											"
											:label="'* ' + $t('fields.buyer')"
											:readonly="fromGroupLock"
										></Dropdown>
									</v-flex>
									<v-flex v-if="invoice.subject_changed" xs12>
										<v-btn @click="updateSubject">
											{{ $t("buttons.updateSubject") }}
										</v-btn>
									</v-flex>
									<v-flex xs12>
										<DateTimePicker
											v-model="invoice.time_of_issue"
											:dateLabel="
												'* ' +
													$t(
														'fields.invoiceDateAndTime'
													)
											"
											:error="
												invoiceValidation.time_of_issue
											"
											:readonly="readonly"
											:timeLabel="''"
										/>
									</v-flex>
									<v-flex xs12>
										<DateTimePicker
											v-model="invoice.due_date"
											:dateLabel="
												'* ' +
													$t('fields.paymentDueDate')
											"
											:error="invoiceValidation.due_date"
											:readonly="readonly"
											:timeLabel="''"
										/>
									</v-flex>
								</v-layout>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex md6 pa-1 xs12>
						<v-card>
							<v-card-text>
								<v-layout row wrap>
									<v-flex xs12>
										<v-flex xs12>
											<Dropdown
												v-model="
													invoice.payment_account_id
												"
												:ajax="true"
												:data="'payment-accounts'"
												:error="
													invoiceValidation.payment_account_id
												"
												:label="
													'* ' + $t('fields.account')
												"
												:readonly="
													fromGroupLock ||
														invoice.id != 0
												"
											></Dropdown>
										</v-flex>
									</v-flex>
									<v-flex xs12 v-show="false">
										<RateField
											v-model="invoice.currency_rate"
											:error="
												invoiceValidation.currency_rate
											"
											:label="$t('fields.eurRate')"
										></RateField>
									</v-flex>
								</v-layout>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex pa-1 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<v-layout row wrap>
									<v-flex xs12>
										<v-btn @click="addItem">
											<v-icon small>fa-plus</v-icon
											>&nbsp;{{ $t("buttons.addItem") }}
										</v-btn>
									</v-flex>
								</v-layout>
								<v-layout
									v-if="invoiceValidation.items != ''"
									row
									wrap
								>
									<v-flex lg4 sm6 xs12>
										<span class="error--text">{{
											invoiceValidation.items
										}}</span>
									</v-flex>
								</v-layout>
								<v-layout
									v-show="invoice.items.length != 0"
									row
									wrap
								>
									<v-flex class="horizontal-scroll" xs12>
										<v-data-table
											:headers="headers"
											:items="invoice.items"
											hide-actions
										>
											<template #items="props">
												<tr class="item-row">
													<td class="pa-0 pl-1 pt-2">
														<v-tooltip
															v-if="!readonly"
															bottom
														>
															<v-icon
																slot="activator"
																small
																@click="
																	removeItemClick(
																		props.index
																	)
																"
																>fa-trash
															</v-icon>
															<span>{{
																$t(
																	"tooltips.removeItem"
																)
															}}</span>
														</v-tooltip>
													</td>
													<td class="pa-0">
														{{ props.index + 1 }}
													</td>
													<td class="pa-0">
														<InputField
															v-model="
																props.item
																	.description_en
															"
															:label="
																$t('labels.en')
															"
															:readonly="readonly"
														></InputField>
														<InputField
															v-model="
																props.item
																	.description_hr
															"
															:label="
																$t('labels.hr')
															"
															:readonly="readonly"
														></InputField>
													</td>
													<td class="pa-0">
														<CurrencyField
															v-model="
																props.item.price
															"
															:readonly="readonly"
															:simple="true"
														></CurrencyField>
													</td>
													<td class="pa-0">
														<QuantityField
															v-model="
																props.item
																	.quantity
															"
															:readonly="readonly"
															:simple="true"
														></QuantityField>
													</td>
													<td class="pa-0">
														<CurrencyField
															v-model="
																props.item
																	.item_total
															"
															:readonly="true"
															:simple="true"
														></CurrencyField>
													</td>
												</tr>
											</template>
										</v-data-table>
									</v-flex>
									<v-flex class="mt-5" xs12>
										<table class="sub-table">
											<tr>
												<td class="sub-table-left">
													{{
														$t("labels.totalAmount")
													}}
													(EUR):
												</td>
												<td class="sub-table-right">
													<CurrencyField
														v-model="total"
														:readonly="true"
														:simple="true"
													></CurrencyField>
												</td>
											</tr>
										</table>
									</v-flex>
								</v-layout>
								<v-layout row wrap>
									<v-flex xs12>
										<v-btn @click="toggleFooterDetails">
											<v-icon
												v-if="!showFooterDetails"
												small
												>fa-eye</v-icon
											>
											<v-icon
												v-if="showFooterDetails"
												small
												>fa-eye-slash</v-icon
											>
											&nbsp;
											{{
												$t(
													"buttons.showHideFooterDetails"
												)
											}}
										</v-btn>
									</v-flex>
									<v-flex v-if="showFooterDetails" xs12>
										<v-layout row wrap>
											<v-flex xs12>
												<CheckBox
													v-model="
														invoice.show_payment_plan
													"
													:label="
														$t(
															'labels.showPaymentPlan'
														)
													"
													class="filter-enable-checkbox"
												></CheckBox>
											</v-flex>
											<v-flex md6 xs12>
												<TextArea
													v-model="invoice.footer_1"
													:error="
														invoiceValidation.footer_1
													"
													:label="$t('fields.footer')"
												/>
											</v-flex>
											<v-flex md6 xs12>
												<TextArea
													v-model="invoice.footer_2"
													:error="
														invoiceValidation.footer_2
													"
													:label="$t('fields.footer')"
												/>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField";
import CheckBox from "./trinkets/CheckBox";
import Dropdown from "./trinkets/Dropdown";
import TextArea from "./trinkets/TextArea";
import UploadMultiple from "./trinkets/UploadMultiple";
import DatePicker from "./trinkets/DatePicker";
import DateTimePicker from "./trinkets/DateTimePicker";
import CurrencyField from "./trinkets/CurrencyField";
import QuantityField from "./trinkets/QuantityField";
import Email from "./modals/Email";
import RateField from "./trinkets/RateField";

export default {
	name: "Invoice",
	components: {
		RateField,
		UploadMultiple,
		CheckBox,
		InputField,
		Dropdown,
		TextArea,
		DatePicker,
		DateTimePicker,
		CurrencyField,
		QuantityField,
		Email
	},
	props: {
		id: Number,
		action: String
	},
	data: function() {
		return {
			cancelEnabled: false,
			readonly: false,
			initialLoad: false,
			invoice: {
				id: this.$route.params.id,
				number: "",
				customer_type: "people",
				time_of_issue: null,
				due_date: null,
				currency_rate: "",
				show_payment_plan: false,
				footer_1:
					"For bookings made more than 30 days before trip:\nDeposit payment: 30% of total amount at the time of booking\nBalance payment: 70% of the total amount 30 days before arrival.",
				footer_2:
					"For bookigns made less than 30 days before trip day.\n100% payment at the time of booking",
				cancels: null,
				cancelled_by: null,
				amount: 0,
				subject_id: null,
				payment_account_id: null,
				items: [],
				subject_changed: false,
				subject_data: {},
				tour_group_id: null,
				prepaid: false
			},
			invoiceValidation: {
				id: "",
				number: "",
				customer_type: "",
				time_of_issue: "",
				due_date: "",
				currency_rate: "",
				show_payment_plan: "",
				footer_1: "",
				footer_2: "",
				cancels: "",
				cancelled_by: "",
				amount: "",
				subject_id: "",
				payment_account_id: "",
				items: ""
			},
			showFooterDetails: false,
			total: 0,
			totalHrk: 0,
			itemTemplate: {
				description_en: "",
				description_hr: "",
				price: 0,
				price_hrk: 0,
				quantity: 1,
				item_total: 0,
				item_total_hrk: 0
			},
			headers: [
				{
					text: "",
					sortable: false,
					value: "actions",
					width: "50px",
					class: "pa-0"
				},
				{
					text: "Id",
					sortable: false,
					value: "item_id",
					width: "50px",
					class: "pa-0"
				},
				{
					text: this.$t("fields.item"),
					sortable: false,
					value: "item",
					class: "pa-2 description-width"
				},
				{
					text: this.$t("fields.price") + " EUR",
					sortable: false,
					value: "price",
					class: "pa-2",
					width: "150px"
				},
				{
					text: this.$t("fields.quantity"),
					sortable: false,
					value: "quantity",
					class: "pa-2",
					width: "150px"
				},
				{
					text: this.$t("fields.total") + " EUR",
					sortable: false,
					value: "total",
					class: "pa-2",
					width: "150px"
				}
			],
			newSubjectData: null,
			sendModalShow: false,
			sendModalId: null,
			changesHappened: false,
			tourGroupAmount: null
		};
	},
	watch: {
		invoice: {
			handler: function() {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
		"invoice.customer_type": {
			handler: function() {
				if (this.initialLoad) {
					this.invoice.subject_id = null;
				}
			},
			deep: true
		},
		"invoice.time_of_issue": {
			handler: function() {
				this.loadCurrencyRate();
				this.calculateDue();
			},
			deep: true
		},
		"invoice.items": {
			handler: function() {
				this.calculateTotals();
			},
			deep: true
		},
		"invoice.currency_rate": {
			handler: function() {
				this.calculateTotals();
			},
			deep: true
		}
	},
	computed: {
		fromGroupLock() {
			return this.$route.params.action == "group";
		}
	},
	methods: {
		pdfClick() {
			this.saveAction(false, true);
		},
		sendModalCallback() {
			this.sendModalShow = false;
			// this.reloadData(this.lastRequest);
		},
		emailClick() {
			this.saveAction(true);
		},
		toggleFooterDetails() {
			this.showFooterDetails = !this.showFooterDetails;
		},
		calculateTotals() {
			let invoiceTotal = 0;
			let invoiceTotalHrk = 0;
			for (let index in this.invoice.items) {
				let item = this.invoice.items[index];
				let total = item.price * item.quantity;
				let priceHrk = item.price * this.invoice.currency_rate;
				let totalHrk = priceHrk * item.quantity;
				this.invoice.items[index].price_hrk = priceHrk;
				this.invoice.items[index].item_total = total;
				this.invoice.items[index].item_total_hrk = totalHrk;
				invoiceTotal += total;
				invoiceTotalHrk += totalHrk;
			}
			this.total = invoiceTotal;
			this.totalHrk = invoiceTotalHrk;
		},
		addItem() {
			if (this.invoice.items.length < 15) {
				let newItem = JSON.parse(JSON.stringify(this.itemTemplate));
				this.invoice.items.push(newItem);
			} else {
				this.$alert(this.$t("alerts.invoiceMaxItems"));
			}
		},
		removeItemClick(itemIndex) {
			let vm = this;
			this.$verify(this.$t("alerts.removalQuestion"), result => {
				if (result) {
					vm.invoice.items.splice(itemIndex, 1);
				}
			});
		},
		loadCurrencyRate() {
			if (this.initialLoad) {
				let vm = this;
				this.$APICall(
					"get",
					"currencies/EUR",
					{ date: this.invoice.time_of_issue },
					(data, success) => {
						if (success) {
							if (data.rate != null) {
								vm.invoice.currency_rate = data.rate;
							} else {
								vm.invoice.currency_rate = 1;
							}
						}
					},
					true
				);
			}
		},
		calculateDue() {
			if (this.initialLoad) {
				if (this.$dateTimePattern.test(this.invoice.time_of_issue)) {
					let moment = require("moment");
					let timeOfIssue = moment(this.invoice.time_of_issue);
					this.invoice.due_date = timeOfIssue
						.add(20, "days")
						.format("YYYY-MM-DD HH:mm:ss");
				}
			}
		},
		backClick() {
			this.$router.go(-1);
		},
		saveClick() {
			if (this.tourGroupAmount === null) {
				this.saveAction();
			} else {
				if (this.tourGroupAmount < this.total) {
					this.$verify(
						this.$t("alerts.invoiceGroupAmountQuestion"),
						result => {
							if (result) {
								this.saveAction();
							}
						}
					);
				} else {
					this.saveAction();
				}
			}
		},
		saveAction(sendEmail = false, openPdf = false) {
			let success = true;

			if (this.invoice.subject_id == null) {
				success = false;
				this.invoiceValidation.subject_id = this.$t(
					"alerts.fieldError"
				);
			} else {
				this.invoiceValidation.subject_id = "";
			}
			if (
				this.invoice.time_of_issue == null ||
				!this.$dateTimePattern.test(this.invoice.time_of_issue)
			) {
				success = false;
				this.invoiceValidation.time_of_issue = this.$t(
					"alerts.fieldError"
				);
			} else {
				this.invoiceValidation.time_of_issue = "";
			}
			if (this.invoice.due_date == null) {
				success = false;
				this.invoiceValidation.due_date = this.$t("alerts.fieldError");
			} else {
				this.invoiceValidation.due_date = "";
			}
			if (this.invoice.payment_account_id == null) {
				success = false;
				this.invoiceValidation.payment_account_id = this.$t(
					"alerts.fieldError"
				);
			} else {
				this.invoiceValidation.payment_account_id = "";
			}

			let itemTerm = true;
			for (let item of this.invoice.items) {
				if (
					item.description_en.trim() == "" &&
					item.description_hr.trim() == ""
				) {
					itemTerm = false;
				}
			}
			if (!itemTerm) {
				this.invoiceValidation.items = this.$t(
					"alerts.invoiceItemError"
				);
				success = false;
			} else {
				this.invoiceValidation.items = "";
			}

			if (success) {
				let vm = this;
				let action = "post";
				let addition = "";
				if (vm.invoice.id != 0) {
					action = "put";
					addition = "/" + vm.invoice.id;
				}
				vm.$APICall(
					action,
					"invoices" + addition,
					vm.invoice,
					(data, success) => {
						if (success) {
							vm.changesHappened = false;
							if (openPdf) {
								window.open(data.pdf_link);
							}
							if (sendEmail) {
								vm.sendModalId = vm.invoice.id;
								vm.sendModalShow = true;
							}
							if (!sendEmail && !openPdf) {
								if (vm.invoice.id == 0) {
									vm.$notify(vm.$t("alerts.basicAdd"));
								} else {
									vm.$notify(vm.$t("alerts.basicUpdate"));
								}
								vm.$triggerReload();
								vm.$triggerTourReload();
								if (vm.$route.params.action == "group") {
									vm.$router.push("/invoices");
								} else {
									vm.backClick();
								}
							}
						} else {
							if (
								data.internal_message ==
								"invalid sequence later"
							) {
								vm.$alert(vm.$t("alerts.invoiceSequenceLater"));
							} else if (
								data.internal_message ==
								"invalid sequence earlier"
							) {
								vm.$alert(
									vm.$t("alerts.invoiceSequenceEarlier")
								);
							} else if (
								data.internal_message == "invalid year"
							) {
								vm.$alert(vm.$t("alerts.invoiceInvalidYear"));
							} else {
								vm.$alert(vm.$t("alerts.basicError"));
							}
						}
					}
				);
			}
		},
		updateSubject() {
			this.invoice.subject_data = JSON.parse(
				JSON.stringify(this.newSubjectData)
			);
			this.invoice.subject_changed = false;
		},
		cancelClick() {
			this.$verify(
				this.$t("alerts.invoiceCancellationQuestion"),
				result => {
					if (result) {
						this.$router.push(
							"/invoices/" + this.invoice.id + "/cancel"
						);
					}
				}
			);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace("login");
		}
		this.$setSubMenu("Finance");

		if (this.invoice.id != 0) {
			let vm = this;
			vm.$nextTick(() => {
				if (vm.$route.params.action == "edit") {
					this.$APICall(
						"get",
						"invoices/" + this.invoice.id,
						{},
						(data, success) => {
							if (success) {
								let usableData = JSON.parse(
									JSON.stringify(data)
								);
								this.newSubjectData =
									usableData.new_subject_data;
								vm.invoice = usableData;
								if (
									vm.invoice.cancels == null &&
									vm.invoice.cancelled_by == null
								) {
									vm.cancelEnabled = true;
								}
								vm.$myStore.commit("setBreadcrumbs", [
									{
										text: vm.$t("modules.invoices"),
										href: "/#/invoices",
										disabled: false
									},
									{
										text: vm.invoice.number,
										href: "/#/invoices/" + vm.invoice.id,
										disabled: true
									}
								]);
								vm.$nextTick(() => {
									vm.initialLoad = true;
								});
							} else {
								vm.$alert(vm.$t("alerts.basicError"));
							}
						}
					);
				}
				if (vm.$route.params.action == "cancel") {
					this.$APICall(
						"get",
						"invoices/" + this.invoice.id,
						{},
						(data, success) => {
							if (success) {
								let usableData = JSON.parse(
									JSON.stringify(data)
								);
								usableData.cancels = usableData.id;
								usableData.id = 0;
								usableData.subject_changed = false;
								let moment = require("moment");
								usableData.time_of_issue = moment().format(
									"YYYY-MM-DD HH:mm:ss"
								);
								for (let itemKey in usableData.items) {
									usableData.items[itemKey].quantity *= -1;
								}
								usableData.tour_group_id = null;

								vm.invoice = usableData;
								vm.cancelEnabled = false;
								vm.$myStore.commit("setBreadcrumbs", [
									{
										text: vm.$t("modules.invoices"),
										href: "/#/invoices",
										disabled: false
									},
									{
										text: this.$t("modules.newInvoice"),
										href: "/#/invoices/" + vm.invoice.id,
										disabled: true
									}
								]);
								vm.$nextTick(() => {
									vm.initialLoad = true;
								});
							} else {
								vm.$alert(vm.$t("alerts.basicError"));
							}
						}
					);
				}
				if (vm.$route.params.action == "group") {
					this.$APICall(
						"get",
						"tours-groups/" + this.invoice.id,
						{},
						(data, success) => {
							if (success) {
								let usableData = JSON.parse(
									JSON.stringify(data)
								);
								vm.invoice.tour_group_id = vm.invoice.id;
								vm.invoice.id = 0;
								vm.invoice.customer_type =
									usableData.billing_type;
								vm.$nextTick(() => {
									vm.invoice.subject_id =
										usableData.subject_id;
								});
								vm.invoice.payment_account_id =
									usableData.payment_account_id;

								let total = 0;
								for (let guest of data.guests) {
									let newItem = JSON.parse(
										JSON.stringify(this.itemTemplate)
									);
									newItem.description_en =
										usableData.tour.tour_category
											.invoice_account_item_en +
										" - " +
										guest.person.first_name +
										" " +
										guest.person.last_name;
									newItem.description_hr =
										usableData.tour.tour_category
											.invoice_account_item_hr +
										" - " +
										guest.person.first_name +
										" " +
										guest.person.last_name;
									newItem.price = guest.price;
									vm.invoice.items.push(newItem);
									total += guest.price;
								}
								vm.tourGroupAmount = total;

								vm.initialLoad = true;
								let moment = require("moment");
								vm.invoice.time_of_issue = moment().format(
									"YYYY-MM-DD HH:mm:ss"
								);
								vm.loadCurrencyRate();
								vm.showFooterDetails = true;
								vm.invoice.show_payment_plan = true;
								vm.$myStore.commit("setBreadcrumbs", [
									{
										text: this.$t("modules.invoices"),
										href: "/#/invoices",
										disabled: false
									},
									{
										text: this.$t("modules.newInvoice"),
										href: "/#/invoices/0",
										disabled: true
									}
								]);
								vm.$APICall(
									"get",
									"subjects/prepaid",
									{},
									(data, success) => {
										if (success) {
											if (
												data[vm.invoice.subject_id]
													.amount > 0
											) {
												vm.$verify(
													this.$t(
														"alerts.prepaidQuestion"
													),
													result => {
														vm.invoice.prepaid = result;
													}
												);
											}
										} else {
											vm.$alert(
												vm.$t("alerts.basicError")
											);
										}
									},
									true
								);
							} else {
								vm.$alert(vm.$t("alerts.basicError"));
							}
						}
					);
				}
			});
		} else {
			let moment = require("moment");
			this.invoice.time_of_issue = moment().format("YYYY-MM-DD HH:mm:ss");
			this.loadCurrencyRate();
			this.$myStore.commit("setBreadcrumbs", [
				{
					text: this.$t("modules.invoices"),
					href: "/#/invoices",
					disabled: false
				},
				{
					text: this.$t("modules.newInvoice"),
					href: "/#/invoices/0",
					disabled: true
				}
			]);
			this.initialLoad = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.changesHappened) {
			this.$verify(this.$t("alerts.leaveQuestion"), result => {
				next(result);
			});
		} else {
			next(true);
		}
	}
};
</script>

<style scoped>
>>> .description-width {
	min-width: 250px;
}

>>> .horizontal-scroll {
	overflow-x: auto;
}

.sub-table {
	width: 100%;
}

.sub-table-left {
	text-align: right;
}

.sub-table-right {
	width: 150px;
}

>>> .sub-table-right input {
	text-align: right;
	font-weight: bold;
}
</style>
